import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["title"]

import {
  TUIChatService,
  TUIStore,
  StoreName,
  IConversationModel,
  SendMessageParams,
  SendMessageOptions,
  TUITranslateService
} from '../../../../@aidesk/uikit-engine';
import vue from '../../../../adapter-vue';
import { isPC, isH5 } from '../../../../utils/env';
import ToolbarItemContainer from '../toolbar-item-container/index.vue';
import imageIcon from '../../../../assets/image.svg';
import imageUniIcon from '../../../../assets/image-uni.png';
import { getTo, isEnabledMessageReadReceiptGlobal } from '../../../../utils/utils';
import Log from '../../../../utils/logger';
import { Toast, TOAST_TYPE } from '../../../common/Toast/index-web';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  // Image source: only valid for uni-app version, web version only supports selecting images from the album.
  // album: Select from album
  // camera: Take a photo using the camera
  imageSourceType: {
    type: String,
    default: 'album',
  },
  isH5ToolShow: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
  }
},
  setup(__props) {

const { ref, computed } = vue;

const props = __props;

const inputRef = ref();
const currentConversation = ref<IConversationModel>();
const IMAGE_TOOLBAR_SHOW_MAP = {
  web_album: {
    icon: imageIcon,
    title: props.title || TUITranslateService.t("图片"),
  },
  uni_album: {
    icon: imageUniIcon,
    title: props.title || TUITranslateService.t("图片"),
  }
};

TUIStore.watch(StoreName.CONV, {
  currentConversation: (conversation: IConversationModel) => {
    currentConversation.value = conversation;
  },
});

const imageToolbarForShow = computed((): { icon: string; title: string } => {
  if (isH5) {
    return IMAGE_TOOLBAR_SHOW_MAP['uni_album'];
  }
  else {
    return IMAGE_TOOLBAR_SHOW_MAP['web_album'];
  }
});

const onIconClick = () => {
  if (inputRef.value?.click) {
    inputRef.value.click();
  }
};

const sendImageInWeb = (e: any) => {
  if (e?.target?.files?.length <= 0) {
    return;
  }
  const file = e.target.files[0];
  if (!file || !file.size) {
    return;
  }
  if (file.type.startsWith('image/')) {
    // 处理图片文件
    sendImageMessage(e.target);
  } else if (file.type.startsWith('video/')) {
    // 处理视频文件
    sendVideoMessage(e.target);
  }

  e.target.value = '';
};

const sendImageMessage = (files: any) => {
  if (!files) {
    return;
  }
  const options = {
    to: getTo(currentConversation?.value),
    conversationType: currentConversation?.value?.type,
    payload: {
      file: files,
    },
    needReadReceipt: isEnabledMessageReadReceiptGlobal(),
  } as SendMessageParams;
  const sendMessageOptions: SendMessageOptions = {};
  TUIChatService.sendImageMessage(options, sendMessageOptions)
  .catch((err) => {
    Toast({
      message:
        err.code === 2253 ? 
          TUITranslateService.t('AIDesk.image 大小超过 20MB，无法发送') 
        : err.message,
      type: TOAST_TYPE.ERROR,
      duration: 5000,
    });
    Log.l(`Send Image Failed:${err.code} ${err.message}`);
  });
};
const sendVideoMessage = (file: any) => {
  if (!file) {
    return;
  }
  const options = {
    to: getTo(currentConversation?.value),
    conversationType: currentConversation?.value?.type,
    payload: {
      file,
    },
    needReadReceipt: isEnabledMessageReadReceiptGlobal(),
  } as SendMessageParams;
  const sendMessageOptions: SendMessageOptions = {};
  TUIChatService.sendVideoMessage(options, sendMessageOptions)
  .catch((err) => {
    Toast({
      message:
        err.code === 2351 ? 
          TUITranslateService.t('AIDesk.video 大小超过 100MB，无法发送') 
        : err.message,
      type: TOAST_TYPE.ERROR,
      duration: 5000,
    });
    Log.l(`Send Video Failed:${err.code} ${err.message}`);
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ToolbarItemContainer, {
    iconFile: _unref(imageToolbarForShow).icon,
    title: _unref(imageToolbarForShow).title,
    iconWidth: "20px",
    iconHeight: "20px",
    needDialog: false,
    onOnIconClick: onIconClick,
    isH5ToolShow: __props.isH5ToolShow
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(['image-upload', !_unref(isPC) && 'image-upload-h5','image-video'])
      }, [
        _createElementVNode("input", {
          ref_key: "inputRef",
          ref: inputRef,
          title: props.title || _unref(TUITranslateService).t('图片'),
          type: "file",
          accept: "image/gif,image/jpeg,image/jpg,image/png,image/bmp,image/webp,video/mov,video/mp4",
          onChange: sendImageInWeb
        }, null, 40, _hoisted_1)
      ], 2)
    ]),
    _: 1
  }, 8, ["iconFile", "title", "isH5ToolShow"]))
}
}

})